export default __webpack_public_path__ + "10222b5c817f74b473a1b49df4441157.png";